module.exports = __webpack_public_path__ + "static/media/map-pin-filled-active.f70c19b2.svg";